import CONFIG from "Config";

import {Utils} from "./utils";

// swr fetcher
export default async function fetcher(resource: string, init: RequestInit) {
    const res = await fetch(resource, {
        ...init,
        credentials: "include",
        headers: {
            "x-ui-location": Utils.getViewName() || ""
        }
    });
    const result = await res.json();

    // If the status code is not in the range 200-299
    if (!res.ok) {
        if (res.status === 401) {
            Utils.clearLocalstorage();
            location.replace(CONFIG.paths.base + "login");
        }

        throw new Error(result && result.result && result.result.message || "");
    }

    return result;
}
